import { render, staticRenderFns } from "./works.vue?vue&type=template&id=03378494&scoped=true&"
import script from "./works.vue?vue&type=script&lang=js&"
export * from "./works.vue?vue&type=script&lang=js&"
import style0 from "./works.vue?vue&type=style&index=0&id=03378494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03378494",
  null
  
)

export default component.exports